import type { ReadConfig } from 'api-read-hook';

import { useApiRead } from 'api-read-hook';

export type V = {
  '@id': string;
  '@type': 'CompanyUptime';
  aggregateState: string;
  resources: Array<{
    '@id': string;
    '@type': 'CompanyUptimeResource';
    publicName: string;
    status: string;
    availability: number | null;
    resourceType: string | null;
    statusHistory: Array<{
      '@id': string;
      '@type': 'CompanyUptimeResourceDay';
      day: string;
      status: string;
      downtimeDuration: number;
      maintenanceDuration: number;
    }>;
  }>;
  reports: Array<{
    '@id': string;
    '@type': 'CompanyUptimeReport';
    title: string;
    reportType: string;
    startsAt: string;
    endsAt: string | null;
    aggregateState: string;
    affectedResources: Array<string>;
    statusUpdates: Array<{
      '@id': string;
      '@type': 'CompanyUptimeUpdate';
      message: string;
      publishedAt: string;
    }>;
  }>;
};

export function useReadItemUptimeStatus(id: string, options?: ReadConfig) {
  return useApiRead<V>(`/companies/${id}/uptime-status`, options);
}
